<div class="card_container pointer"
     [class.from_popular]="type === productCardEnum.POPULAR"
     [class.from_collection]="type === productCardEnum.COLLECTION"
>
  <div class="card_info">
    <div class="product_card_image_container flow_hide pointer flex_center_align_center"
         (click)="getSingleProductInfo()">
      <img [src]="productCard.resourceUrls[0].resourceUrl" loading="lazy">
      <div class="delivery_price" *ngIf="productCard.deliveryPrice">
        <app-delivery-info [data]="{value:productCard.deliveryPrice , useType: 'product', type: 'deliveryPrice'}">
        </app-delivery-info>
      </div>
      <div class="delivery_time" *ngIf="(productCard.deliveryTime | millisecondsToMinutes) as delivery">
        <app-delivery-info [data]="{value: (delivery | priceSpaces), useType: 'product', type: 'deliveryTime'}">
        </app-delivery-info>
      </div>
<!--      <div class="discount">-->
<!--        -25%-->
<!--      </div>-->
        <div class="have_order_blur_block flex_center_align_center" *ngIf="productCard.countInBasket">
        <div class="w_50">
          <div class="count_item_in_basket">
            {{productCard.countInBasket}}
          </div>
          <div class="item_in_basket">
            {{'product.item_in_your_cart' | translate}}
          </div>
        </div>
      </div>
      <div class="free_delivery" *ngIf="productCard.deliveryPrice === 0">
        {{'product.freeDeliveryForCards' | translate}}
      </div>
    </div>
    <div class="info flex_column_between">
      <div class="mouse_leave">
        <div class="flex_align_center">
          <span class="product_price">{{productCard.price | priceSpaces}} ₽</span>
          <app-bonus-display class="ml_4" [bonus]="productCard.bonusAmount"></app-bonus-display>
        </div>
        <span class="title_description mt_4">{{productCard.title}}</span>
        <app-star-rate [rate]="productCard.averageRate"
                       [rateCount]="productCard.rateCount"
        >
        </app-star-rate>
      </div>
      <div class="shop_info mt_18" *ngIf="productCard.shop">
        <div class="shop_logo_and_title flex_align_center pointer" (click)="goToShopDetailsPage()">
          <div class="shop_logo">
            <img [src]="productCard.shop.imageUrl">
          </div>
          <span class="shop_title bold_700 ml_8">
          {{productCard.shop.shopName}}
        </span>
        </div>
<!--              <div class="delivery font_15 bold"-->
<!--                   *ngIf="(productCard.deliveryTime | millisecondsToMinutes) as delivery">-->
<!--                {{'product.catalog.delivery' | translate}} {{delivery | priceSpaces}} мин-->
<!--                <span-->
<!--                  *ngIf="productCard.deliveryPrice != null"-->
<!--                  [ngClass]="{green_text : productCard.deliveryPrice === 0}">-->
<!--                  ,{{ productCard.deliveryPrice  + '₽'}}-->
<!--                </span>-->
<!--              </div>-->
      </div>

      <div class="buy mt_12">
        <button class="add_to_basket_btn main_buttons pointer bold_700 flex_center_align_center br_32"
                *ngIf="!productCard.countInBasket; else numberOfBouquets"
                (click)="addToBasket($event)">
          <img class="desktop_size" src="assets/images/icons/shopping_bag_add.svg">
          <img class="tablet_size" src="assets/images/icons/shopping_bag_add_from_tablet.svg">
          <span class="add_to_basket_text desktop_size">
            {{'product.single_page.add_to_basket' | translate}}
          </span>
          <span class="tablet_size add_to_basket_text_mobile ml_8">
            {{'buttons.add_to_cart' | translate}}
          </span>
        </button>
        <ng-template #numberOfBouquets>
          <app-add-and-reduce [productCard]="productCard" [type]="addAndReduceTypeEnums.GENERAL">
          </app-add-and-reduce>
        </ng-template>
      </div>
    </div>
    <app-add-to-favorites-button
      [id]="productCard.id"
      [classTransparent]="true"
      [type]="addToFavoriteTypeEnum.PRODUCT"
      [liked]="productCard.liked"
      (favoriteChangeEventEmitter)="disLike($event)"
    >
    </app-add-to-favorites-button>
  </div>
</div>
